import { useCallback, useMemo, useState } from 'react'
import { SearchBarCheckBox } from '../../../baseComponents/SearchBar'
import TwinIcon, { TwinIconProp } from '../../../baseComponents/TwinIcon'
import Checkbox from '../../../forms/Checkbox'
import { ChangeValueFunc } from '../../../utils/globals/types'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { MultipleCbxSelectorValues } from '../types'
import { ItemCustomSelectDropDownRow } from '../../CustomSelect/DropDown/types'
import { filterArrayItems } from '../../../utils/globals/array'
import { TwinDictionary } from '../../../utils/globals/dictionary'

interface SingleColumnSelectorProps {
    options: ItemCustomSelectDropDownRow[]
    onChange: (value: string) => void
    values: MultipleCbxSelectorValues
    onChangeAll: (value: boolean, items: TwinDictionary[]) => void
    subtitle?: string
    readOnly?: boolean
    className?: string
}

export const SingleColumnSelector: React.FC<SingleColumnSelectorProps> = ({ onChange, values, onChangeAll, subtitle, options, readOnly, className }) => {
    const { t } = useTwinTranslation()
    const { searchValue, changeSearchValue, arrFilteredItems } = useSelectorLogic({ options })
    const renderOptions: JSX.Element[] = []
    for (const item of arrFilteredItems) {
        const option = item.text
        const value = String(item.value)
        renderOptions.push(<div key={value} className='option_selector' div-value={value}><Checkbox label={String(option)} onChange={() => onChange(value)} checked={values.includes(value)} readOnly={readOnly} /></div>)
    }
    const checked = values.length === Object.keys(arrFilteredItems).length && values.length > 0
    return (
        <div className={'flex-col selector_column ' + (className || '')}>
            <span className='subtitle block medium14 my-20 twin_elipsis '>{subtitle}</span>
            <div className='selector'>
                <SearchBarCheckBox onChangeCheckbox={(value)=>onChangeAll(value, arrFilteredItems)} className='selector_searchbar' placeholder={t('search', 'Buscar')} onChange={changeSearchValue} {...{ searchValue, checked, readOnly }} />
                <div className='options_container'>
                    {renderOptions}
                </div>
            </div>
        </div>
    )
}

interface SelectorLogicProps {
    options: ItemCustomSelectDropDownRow[]
}
export const useSelectorLogic = ({ options }: SelectorLogicProps) => {
    const [searchValue, setSearchValue] = useState<string>('')
    const arrFilteredItems = useMemo(() => filterArrayItems(searchValue, options, 'text'), [options, searchValue])

    const changeSearchValue: ChangeValueFunc = useCallback((myvalue) => {
        setSearchValue(myvalue)
    }, [setSearchValue])

    return { searchValue, changeSearchValue, arrFilteredItems }
}

interface MiddleIconsButtonsProps {
    onClick: () => void
    children?: React.ReactNode
    className?: string
}

export const MiddleIconsButton: React.FC<MiddleIconsButtonsProps> = ({ onClick, children, className }) => {
    return (
        <div className={'middle_icons_button ' + (className || '')} onClick={onClick}>
            {children}
        </div>
    )
}
interface MiddleIconsDoubleIconProps extends MiddleIconsButtonsProps {
    icon: TwinIconProp
}
export const MiddleIconsDoubleIcon: React.FC<MiddleIconsDoubleIconProps> = ({ icon, onClick, className }) => {
    return (
        <MiddleIconsButton className={className} onClick={onClick}>
            <TwinIcon icon={icon} className=' mr-6' />
            <TwinIcon icon={icon} className=' mr-6' />
        </MiddleIconsButton>
    )
}